import AOS from 'aos';

class Animations {
  constructor() {
    this._init = false;
  }

  static setDelay() {
    [...document.querySelectorAll('[data-aos-delay]')].forEach(el => {
      el.style.animationDelay = `${el.getAttribute('data-aos-delay')}ms`;
    });
  }

  init() {
    Animations.setDelay();

    if (!this._init) {
      AOS.init({
        // Global settings
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded',
        offset: 120,
        easing: 'ease',
        once: true,
        disableMutationObserver: true
      });
      this._init = true;
    } else {
      AOS.refreshHard();
    }
  }
}

export default new Animations();
